import { FEATURE_KEYS } from '../../utils/featureUtils';

/**
 * Defines which plan-usage bars are shown globally and on which URL paths.
 *
 * Each entry supports:
 *   featureKey        {string}            – canonical key from FEATURE_KEYS
 *   matchPaths        {string[]}          – bar renders only when pathname starts with one of these
 *   exactMatch        {boolean}           – if true, pathname must match exactly (not just startsWith)
 *   label             {string | object}   – plain string OR { normal, warning, critical }
 *   unitLabel         {string}            – unit noun shown next to the count
 *   upgradeTitle      {string}            – heading in the upgrade modal
 *   upgradeDescription{string}            – subtext in the upgrade modal
 *   healthyThreshold  {number}            – ratio below which the bar is hidden (default 0.75)
 *   showUpgradeButton {boolean}           – whether to show the inline upgrade button (default true)
 */

const FEATURE_BARS = [
	{
		featureKey: FEATURE_KEYS.CONTACTS,
		matchPaths: ['/contacts'],
		label: 'Contacts',
		unitLabel: 'contacts',
		upgradeTitle: 'Upgrade your plan for more contacts',
		upgradeDescription: 'Choose a plan below to increase your contact allowance.',
	},
	{
		featureKey: FEATURE_KEYS.EMPLOYEES,
		matchPaths: ['/employees'],
		label: {
			normal: 'Employees',
			warning: 'You are about to reach your employee limit',
			critical: 'You have reached your employee limit',
		},
		unitLabel: 'employees',
		upgradeTitle: 'Upgrade your plan for more employees',
		upgradeDescription:
			'Choose a plan below to increase your employee allowance.',
		healthyThreshold: 0.85,
	},
	{
		featureKey: FEATURE_KEYS.CLIENTS,
		matchPaths: ['/clients/add'],
		label: {
			normal: 'Clients',
			warning: 'You are approaching your client limit',
			critical: 'You have reached your client limit',
		},
		unitLabel: 'clients',
		upgradeTitle: 'Upgrade your plan for more clients',
		upgradeDescription: 'Choose a plan below to increase your client allowance.',
		healthyThreshold: 0.75,
	},
	{
		featureKey: FEATURE_KEYS.PROJECTS,
		matchPaths: ['/projects', '/projects/add'],
		label: {
			normal: 'Projects',
			warning: 'You are approaching your project limit',
			critical: 'You have reached your project limit',
		},
		unitLabel: 'projects',
		upgradeTitle: 'Upgrade your plan for more projects',
		upgradeDescription: 'Choose a plan below to increase your project allowance.',
		healthyThreshold: 0.75,
	},
	{
		featureKey: FEATURE_KEYS.EMAIL_BUILDER,
		matchPaths: ['/builder/email', '/builder/email/', '/builder/email/simple'],
		exactMatch: false,
		label: {
			normal: 'Email Builder Templates',
			warning: 'You are approaching your template limit',
			critical: 'You have reached your template limit',
		},
		unitLabel: 'templates',
		upgradeTitle: 'Upgrade your plan for more email builder templates',
		upgradeDescription:
			'Choose a plan below to increase your template allowance.',
		healthyThreshold: 0.75,
		showUpgradeButton: false,
	},
	{
		featureKey: FEATURE_KEYS.AI_WORDPRESS_CONTENT,
		matchPaths: ['/connected-sites/', '/generate-ai-content'],
		label: {
			normal: 'AI WordPress content',
			warning: 'You are approaching your monthly AI content limit',
			critical: 'You have reached your monthly AI content limit',
		},
		unitLabel: 'AI posts',
		upgradeTitle: 'Upgrade your plan for more AI content',
		upgradeDescription:
			'Choose a plan below to increase your monthly AI WordPress content allowance.',
		healthyThreshold: 0.75,
	},
];

export default FEATURE_BARS;
